import { FeaturesConfig } from "../../../environments/appEnvironmentConfig";

export interface FeatureFlagRouteData {
  featureFlag: keyof FeaturesConfig;
}

export function getFeatureFlagFromRouteData(data: unknown): keyof FeaturesConfig | null {
  if (data === null || typeof data !== "object") {
    return null;
  }

  const routeData = data as Record<string, unknown>;
  const featureFlag = routeData["featureFlag"];

  if (typeof featureFlag !== "string") {
    return null;
  }

  return featureFlag as keyof FeaturesConfig;
}
